// 全局配置 ////////////////////////////////////////////////////////////////////////////////////

import { JSEncrypt } from 'jsencrypt'

// 获取企业
const domain = document.domain
const string = domain.indexOf('.')
const xcompany = domain.substring(0, string)
export const companyCode = document.domain !== 'localhost' && document.domain !== '192.168.3.2' ? xcompany : 'uifox'

const routers = ['/login', '/forget-password', '/aboutUs', '/contactUs', "/robot", '/register']
const agentRouters = ['/forget-password', '/aboutUs', '/contactUs', "/robot", '/register', '/notFind', '/login']

// 无需权限路由集合
export const whiteList = agentRouters

// 登录秘钥
const publicKey = 'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBANL378k3RiZHWx5AfJqdH9xRNBmD9wGD2iRe41HdTNF8RUhNnHit5NpMNtGL0NPTSSpPjjI1kJfVorRvaQerUgkCAwEAAQ=='
// 加密
export const Encrypt = (txt) => {
	const encryptor = new JSEncrypt()
	encryptor.setPublicKey(publicKey) // 设置公钥
	return encryptor.encrypt(txt) // 对需要加密的数据进行加密
}

// 定时信息
export const TimingInfo = [
	{ key: 'API', label: 'API' },
	{ key: 'CRON', label: 'CRON' },
	{ key: 'PL', label: '固定频率(毫秒)' },
	{ key: 'YC', label: '固定延迟(毫秒)' },
	{ key: 'GZL', label: '工作流' },
]

// 执行类型
export const RunningType = [
	{ key: 'DJ', label: '单机执行' },
	{ key: 'GB', label: '广播执行' },
	{ key: 'MAP', label: 'Map执行' },
	{ key: 'REDUCE', label: 'MapReduce执行' },
]

// 处理器信息
export const ProcessorType = [
	{ key: 'DJ', label: 'JAVA', tip: '全限定类名，eg：com.github.kfcfans.DemoProcessor' },
	{ key: 'GB', label: 'JAVA(容器)', tip: '容器ID#全限定类名，eg：1#com.github.kfcfans.DemoProcessor' },
	{ key: 'MAP', label: 'SHELL', tip: 'SHELL脚本文件内容' },
	{ key: 'REDUCE', label: 'PYTHON', tip: 'PYTHON脚本文件内容' },
]

// 任务状态
export const TaskStatus = [
	{ status: '', key: '', label: '全部' },
	{ status: 1, key: 'WAITING_DISPATCH', label: '等待派发' },
	{ status: 2, key: 'WAITING_WORKER_RECEIVE', label: '等待接收' },
	{ status: 3, key: 'RUNNING', label: '运行中' },
	{ status: 4, key: 'FAILED', label: '运行失败' },
	{ status: 5, key: 'SUCCEED', label: '运行成功' },
	{ status: 9, key: 'CANCELED', label: '手动取消' },
	{ status: 10, key: 'STOPPED', label: '手动停止' },
]

export const TaskType = [
	{ value: 'immediate', label: '立即执行' },
	{ value: 'specified_time', label: '执行一次' },
	{ value: 'specified_interval_time', label: '每隔' },
	{ value: 'day_interval', label: '每日重复' },
	{ value: 'week_interval', label: '每周重复' },
	{ value: 'month_interval', label: '每月重复' },
]

export const weekList = [
	{ value: '2', label: '周一' },
	{ value: '3', label: '周二' },
	{ value: '4', label: '周三' },
	{ value: '5', label: '周四' },
	{ value: '6', label: '周五' },
	{ value: '7', label: '周六' },
	{ value: '1', label: '周日' },
]

export const specifiedList = [
	{ value: 'intervalMinute', label: '每隔若干分钟' },
	{ value: 'intervalHour', label: '每隔若干小时' },
	{ value: 'intervalDay', label: '每隔若干天' },
]



//  海运跟踪进程
export const trackingType = [
	{ title: '提空箱', step: ['STSP', 'FCGI', 'CGGI', 'CLOD', 'CYTC'], value: '' },
	{ title: '进场', step: ['GITM', 'TMUT'], value: '' },
	{ title: '海放', step: ['PASS'], value: '' },
	{ title: '码放', step: ['TMPS'], value: '' },
	{ title: '配载', step: ['PRLD'], value: '' },
	{ title: '起运港', step: ['LOBD', 'DLPT', 'TSGT', 'TSDP', 'TSLB', 'TSBA', 'TSCA', 'TSDC'], value: '' },
	{ title: '交货港', step: ['BDAR', 'POCA'], value: '' },
	{ title: '卸货', step: ['DSCH'], value: '' },
	{ title: '提货', step: ['STCS'], value: '' },
	{ title: '还箱', step: ['RCVE', 'SUOT', 'CUIP', 'IRDP', 'IRLB', 'IRAR', 'IRDS', 'FDLB', 'FDDP', 'FDBA', 'FDDC'], value: '' },
]


export const trackingDetails = [
	{ type: "BKCF", title: "订舱" },
	{ type: "EPRL", title: "放箱" },
	{ type: "STSP", title: "提空箱" },
	{ type: "FCGI", title: "返场" },
	{ type: "CGGI", title: "入货" },
	{ type: "CLOD", title: "封箱" },
	{ type: "CYTC", title: "集港" },
	{ type: "GITM", title: "进场" },
	{ type: "TMUT", title: "码头退关" },
	{ type: "PASS", title: "海关放行" },
	{ type: "TMPS", title: "码头放行" },
	{ type: "PRLD", title: "配载" },
	{ type: "LOBD", title: "装船" },
	{ type: "DLPT", title: "离港" },
	{ type: "TSGT", title: "中转进场" },
	{ type: "TSDP", title: "中转开航" },
	{ type: "TSLB", title: "中转装船" },
	{ type: "TSBA", title: "中转抵港" },
	{ type: "TSCA", title: "中转停泊" },
	{ type: "TSDC", title: "中转卸船" },
	{ type: "BDAR", title: "抵港" },
	{ type: "POCA", title: "停泊" },
	{ type: "DSCH", title: "卸船" },
	{ type: "STCS", title: "提柜(货)" },
	{ type: "RCVE", title: "还箱" },
	{ type: "SUOT", title: "海关退关" },
	{ type: "CUIP", title: "查验" },
	{ type: "IRLB", title: "铁运装箱" },
	{ type: "IRDP", title: "铁运发车" },
	{ type: "IRAR", title: "铁运到站" },
	{ type: "IRDS", title: "铁运卸箱" },
	{ type: "FDLB", title: "支线装船" },
	{ type: "FDDP", title: "支线离港" },
	{ type: "FDBA", title: "支线抵达" },
	{ type: "FDDC", title: "支线卸船" },
]


// 生成天数
export const returnMonth = (days) => {
	const monthDay = []
	for (let i = 1; i <= days; i++) {
		monthDay.push({ value: i, label: i < 10 ? `0${i}` : `${i}` })
	}
	return monthDay
}

// 全局方法 ////////////////////////////////////////////////////////////////////////////////////



// 重新计算获取显示页码
export const renderNum = (index, current, pageSize) => {
	const newCurrent = current !== 0 ? current : 1
	return (newCurrent - 1) * pageSize + (index + 1)
}

// 设置LocalStorage
export const setLocalStore = (name, content) => {
	if (name === 'Authorization') {
		localStorage.setItem(name, content)
	} else {
		localStorage.setItem(name, JSON.stringify(content))
	}
}

// 获取LocalStorage
export const getLocalStore = (name) => {
	let data
	try {
		const content = localStorage.getItem(name)
		if (content !== null) {
			if (name === 'Authorization') {
				data = content
			} else {
				data = JSON.parse(content)
			}
		}
	} catch (e) { }
	return data
}

// 删除LocalStorage
export const unsetLocalStore = (name) => localStorage.removeItem(name)

// 最大长度
export const maxLength = {
	name: 15,
	code: 30,
}

// js精度计算
export const formatNum = (f, digit) => {
	var m = Math.pow(10, digit)
	return parseInt(f * m, 10) / m
}

// 获取URL参数
export const GetRequest = () => {
	let url = location.href
	let theRequest = {}
	if (url.indexOf("?") != -1) {
		let str = url.substring(url.indexOf("?") + 1)
		let strs = str.split("&")
		for (let i = 0; i < strs.length; i++) {
			theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1])
		}
	}
	return theRequest
}

export const GetPageTag = () => {
	let url = location.href.match(/#(.*)/)
	let value = url !== null ? url[1] : ''
	return value
}

// 数据查询页码处理
export const getPageCurrent = (current, pageSize, total) => {
	return (total - 1) > (current - 1) * pageSize ? current : current - 1
}

// 水印
export const watermark = {
	init: function (settings) {
		window.watermarkdivs = []
		watermark.loadMark(settings)
		window.onresize = function () {
			watermark.loadMark(settings)
		}
	},
	loadMark: function (settings) {
		let defaultSettings = {
			watermark_txt: "测试水印",
			watermark_x: 20,//水印起始位置x轴坐标
			watermark_y: 20,//水印起始位置Y轴坐标
			watermark_rows: 0,//水印行数
			watermark_cols: 0,//水印列数
			watermark_x_space: 20,//水印x轴间隔
			watermark_y_space: 10,//水印y轴间隔
			watermark_font: '微软雅黑',//水印字体
			watermark_color: 'black',//水印字体颜色
			watermark_fontsize: '16px',//水印字体大小
			watermark_alpha: 0.05,//水印透明度，要求设置在大于等于0.003
			watermark_width: 140,//水印宽度
			watermark_height: 50,//水印长度
			watermark_angle: 15,//水印倾斜度数
			divId: 'watermask'
		}
		//采用配置项替换默认值，作用类似jquery.extend
		if (arguments.length === 1 && typeof arguments[0] === "object") {
			let src = arguments[0] || {}
			for (let key in src) {
				if (src[key] && defaultSettings[key] && src[key] === defaultSettings[key])
					continue
				else if (src[key])
					defaultSettings[key] = src[key]
			}
		}

		if (window.watermarkdivs && window.watermarkdivs.length > 0) {
			document.getElementById(defaultSettings.divId).innerHTML = ''
			window.watermarkdivs = []
		}

		//获取页面最大宽度
		const page_width = Math.max(document.body.scrollWidth, document.body.clientWidth)
		//获取页面最大长度
		const page_height = Math.max(document.body.scrollHeight, document.body.clientHeight)

		//  创建文档碎片
		let oTemp = document.createDocumentFragment()
		//创建水印外壳div
		let otdiv = document.getElementById(defaultSettings.divId)

		//如果将水印列数设置为0，或水印列数设置过大，超过页面最大宽度，则重新计算水印列数和水印x轴间隔
		if (defaultSettings.watermark_cols == 0 || (parseInt(defaultSettings.watermark_x + defaultSettings.watermark_width * defaultSettings.watermark_cols + defaultSettings.watermark_x_space * (defaultSettings.watermark_cols - 1)) > page_width)) {
			defaultSettings.watermark_cols = parseInt((page_width - defaultSettings.watermark_x + defaultSettings.watermark_x_space) / (defaultSettings.watermark_width + defaultSettings.watermark_x_space))
			defaultSettings.watermark_x_space = parseInt((page_width - defaultSettings.watermark_x - defaultSettings.watermark_width * defaultSettings.watermark_cols) / (defaultSettings.watermark_cols - 1))
		}
		//如果将水印行数设置为0，或水印行数设置过大，超过页面最大长度，则重新计算水印行数和水印y轴间隔
		if (defaultSettings.watermark_rows == 0 || (parseInt(defaultSettings.watermark_y + defaultSettings.watermark_height * defaultSettings.watermark_rows + defaultSettings.watermark_y_space * (defaultSettings.watermark_rows - 1)) > page_height)) {
			defaultSettings.watermark_rows = parseInt((defaultSettings.watermark_y_space + page_height - defaultSettings.watermark_y) / (defaultSettings.watermark_height + defaultSettings.watermark_y_space))
			defaultSettings.watermark_y_space = parseInt(((page_height - defaultSettings.watermark_y) - defaultSettings.watermark_height * defaultSettings.watermark_rows) / (defaultSettings.watermark_rows - 1))
		}

		let x
		let y
		for (let i = 0; i < defaultSettings.watermark_rows; i++) {
			y = defaultSettings.watermark_y + (defaultSettings.watermark_y_space + defaultSettings.watermark_height) * i
			for (let j = 0; j < defaultSettings.watermark_cols; j++) {
				x = defaultSettings.watermark_x + (defaultSettings.watermark_width + defaultSettings.watermark_x_space) * j

				const mask_div = document.createElement('div')
				const oText = document.createTextNode(defaultSettings.watermark_txt)
				mask_div.appendChild(oText)
				// 设置水印相关属性start
				mask_div.className = 'mask_div'
				//设置水印div倾斜显示
				mask_div.style.webkitTransform = "rotate(-" + defaultSettings.watermark_angle + "deg)"
				mask_div.style.MozTransform = "rotate(-" + defaultSettings.watermark_angle + "deg)"
				mask_div.style.msTransform = "rotate(-" + defaultSettings.watermark_angle + "deg)"
				mask_div.style.OTransform = "rotate(-" + defaultSettings.watermark_angle + "deg)"
				mask_div.style.transform = "rotate(-" + defaultSettings.watermark_angle + "deg)"
				mask_div.style.visibility = ""
				mask_div.style.position = "absolute"
				//选不中
				mask_div.style.left = x + 'px'
				mask_div.style.top = y + 'px'
				mask_div.style.overflow = "hidden"
				mask_div.style.zIndex = "1"
				//mask_div.style.border="solid #eee 1px";
				mask_div.style.opacity = defaultSettings.watermark_alpha
				mask_div.style.fontSize = defaultSettings.watermark_fontsize
				mask_div.style.fontFamily = defaultSettings.watermark_font
				mask_div.style.color = defaultSettings.watermark_color
				mask_div.style.textAlign = "center"
				mask_div.style.width = defaultSettings.watermark_width + 'px'
				mask_div.style.height = defaultSettings.watermark_height + 'px'
				mask_div.style.display = "block"
				//设置水印相关属性end
				//附加到文档碎片中
				otdiv.appendChild(mask_div)

				window.watermarkdivs.push(otdiv) //控制页面大小变化时水印字体
			};
		};
		//一次性添加到document中
		document.body.appendChild(oTemp)
	}
}

/**
 * 返回Cron表达式
 */
export const returnCronExpression = (props) => {
	let {
		name, botId, eventMethod, robotIds, errorHandling, isQueueUpType, taskNumber, email, yearMonthDay, hourMinute,
		isRunNow, scheduleType, specifiedValue, intervalDay, intervalHour, intervalMinute, weeks, month,
		scheduleEndDt, scheduleCron, scheduleStartDt,
	} = props

	// 所有的时间都要转换成Cron 表达式 在此转换
	let cron = ''

	// 高级
	if (scheduleType === 'cron_express') {
		cron = scheduleCron
	}
	// 执行一次
	else if (scheduleType === 'specified_time' && scheduleStartDt !== null) {
		scheduleStartDt = `${yearMonthDay} ${hourMinute}`

		const YMD = yearMonthDay.split('-')
		const HM = hourMinute.split(':')
		cron = `0 ${Number(HM[1])} ${Number(HM[0])} ${Number(YMD[2])} ${Number(YMD[1])} ?`
	}
	// 每隔
	else if (scheduleType === 'specified_interval_time') {
		scheduleStartDt = `${yearMonthDay} ${hourMinute}`

		if (specifiedValue === 'intervalDay') {
			cron = `0 0 0 */${intervalDay} * ?`
		} else if (specifiedValue === 'intervalHour') {
			cron = `0 0 */${intervalHour} * * ?`
		} else if (specifiedValue === 'intervalMinute') {
			cron = `0 */${intervalMinute} * * * ?`
		}
	}
	// *每日重复
	else if (scheduleType === 'day_interval' && hourMinute !== null) {
		const HM = hourMinute.split(':')
		// 0 37 15 * * ?
		cron = `0 ${Number(HM[1])} ${Number(HM[0])} * * ?`
	}
	// *每周重复
	else if (scheduleType === 'week_interval' && hourMinute !== null) {
		const WE = weeks.join(',')
		const HM = hourMinute.split(':')
		// 0 14 13 ? * 2,4,5
		cron = `0 ${Number(HM[1])} ${Number(HM[0])} ? * ${WE}`
	}
	// *每月重复
	else if (scheduleType === 'month_interval' && hourMinute !== null) {
		const MO = month.join(',')
		const HM = hourMinute.split(':')
		// 0 55 12 2,15,27 * ?
		cron = `0 ${Number(HM[1])} ${Number(HM[0])} ${MO} * ?`
	}

	/**
	 * scheduleExpress 前端确定格式 方便查看时解析该数据 便于展示
	 * JSON.stringify后丢给后端
	 * 返回后 解析下 便于查看时展示
	 */
	let scheduleExpress = JSON.stringify({
		name, botId, eventMethod, yearMonthDay, hourMinute,
		robotIds, isRunNow, taskNumber, email,
		errorHandling, isQueueUpType,
		scheduleType, specifiedValue,
		intervalDay, intervalHour, intervalMinute,
		weeks, month, scheduleEndDt,
		scheduleCron, scheduleStartDt
	})

	// 返回接口所需要的数据
	return {
		name, botId, eventMethod, yearMonthDay, hourMinute,
		robotIds, isRunNow, taskNumber, email,
		errorHandling, isQueueUpType,
		scheduleType, specifiedValue,
		intervalDay, intervalHour, intervalMinute,
		weeks, month, scheduleEndDt,
		scheduleCron: cron,
		scheduleExpress,
		scheduleStartDt
	}
}

//返回时分秒
export const timeStamp = (second_time) => {
	let time = parseInt(second_time) + "秒"
	if (parseInt(second_time) > 60) {

		let second = parseInt(second_time) % 60
		let min = parseInt(second_time / 60)
		time = min + "分" + second + "秒"

		if (min > 60) {
			min = parseInt(second_time / 60) % 60
			let hour = parseInt(parseInt(second_time / 60) / 60)
			time = hour + "小时" + min + "分" + second + "秒"

			if (hour > 24) {
				hour = parseInt(parseInt(second_time / 60) / 60) % 24
				let day = parseInt(parseInt(parseInt(second_time / 60) / 60) / 24)
				time = day + "天" + hour + "小时" + min + "分" + second + "秒"
			}
		}
	}
	return time
}



// const regCN = /[\u4E00-\u9FA5]/g;
const regCN = /[^\x00-\xff]/
const regSP = /^\S.*\S$|(^\S{0,1}\S$)/ // 检测空格

const validateCN = (rule, value, callback) => {
	if (regCN.test(value) === true) {
		callback(new Error('不能输入中文及中文字符'))
	} else if (!regSP.test(value)) {
		callback(new Error('首尾不能包含空格'))
	} else {
		if (regCN.test(value) === true) {
			callback(new Error('不能输入中文及中文字符'))
		} else if (!regSP.test(value)) {
			callback(new Error('首尾不能包含空格'))
		} else {
			callback()
		}
	}
}

const validateGJ = (rule, value, callback) => {
	if (value.length > 2) {
		callback(new Error('长度为2'))
	} else {
		if (regCN.test(value) === true) {
			callback(new Error('不能输入中文及中文字符'))
		} else if (!regSP.test(value)) {
			callback(new Error('首尾不能包含空格'))
		} else {
			if (regCN.test(value) === true) {
				callback(new Error('不能输入中文及中文字符'))
			} else if (!regSP.test(value)) {
				callback(new Error('首尾不能包含空格'))
			} else {
				callback()
			}
		}
	}

}


const regex = /^[0-9A-Z]+$/
const validateEX = (rule, value, callback) => {
	if (regex.test(value) === false) {
		callback(new Error('只能输入大写字母和数字'))
	} else if (!regSP.test(value)) {
		callback(new Error('首尾不能包含空格'))
	} else {
		if (regex.test(value) === false) {
			callback(new Error('只能输入大写字母和数字'))
		} else if (!regSP.test(value)) {
			callback(new Error('首尾不能包含空格'))
		} else {
			callback()
		}
	}
}

// 船名检查
const regCM = /^[0-9A-Z-._ ]+$/
const validateCM = (rule, value, callback) => {
	if (regCM.test(value) === false) {
		callback(new Error("只能输入大写字母,数字、'-'、'.'、'_'"))
	} else if (!regSP.test(value)) {
		callback(new Error('首尾不能包含空格'))
	} else {
		if (regCM.test(value) === false) {
			callback(new Error('只能输入大写字母,数字和-和.和_'))
		} else if (!regSP.test(value)) {
			callback(new Error('首尾不能包含空格'))
		} else {
			callback()
		}
	}
}

// 地址
const regDz = /^[0-9A-Z-,/.:#%&*@;'"_()\\ ]+$/
const validateDz = (rule, value, callback) => {
	if (regDz.test(value) === false) {
		callback(new Error('输入不能有中文 & 全角字符'))
	} else if (!regSP.test(value)) {
		callback(new Error('首尾不能包含空格'))
	} else {
		if (regDz.test(value) === false) {
			callback(new Error('输入不能有中文 & 全角字符'))
		} else if (!regSP.test(value)) {
			callback(new Error('首尾不能包含空格'))
		} else {
			callback()
		}
	}
}

const regAdd = /[+]/
const validateAdd = (rule, value, callback) => {
	if (regCN.test(value) === true) {
		callback(new Error('不能输入中文及中文字符'))
	} else if (!regSP.test(value)) {
		callback(new Error('首尾不能包含空格'))
	} else {
		if (regCN.test(value) === true) {
			callback(new Error('不能输入中文及中文字符'))
		} else if (!regSP.test(value)) {
			callback(new Error('首尾不能包含空格'))
		} else if (!regAdd.test(value)) {
			callback(new Error('必须存在+号'))
		} else {
			callback()
		}
	}
}

// 只能输入数字 
const regNum = /^[0-9]+$/
const rulePhone = /^\d{11}$/// 手机号码校验规则

const validateNum = (rule, value, callback) => {
	if (value.length < 1) {
		return callback(new Error('联系电话不能为空'))
	} else if (regNum.test(value) !== true) {
		callback(new Error('只能输入纯数字'))
	} else {
		callback()
	}
}
//通知人、发货人、收货人名称
const regCNN = /^[0-9A-Z-.,"' ]+$/
const validateCNN = (rule, value, callback) => {
	// console.log(1111,regCN.test(value),regNum.test(value),regCNN.test(value));

	if (regCNN.test(value) === false) {
		callback(new Error('不能输入中文及中文字符'))
	} else if (!regSP.test(value)) {
		callback(new Error('首尾不能包含空格'))
	} else if (regNum.test(value) === true) {
		callback(new Error('不允许输入纯数字'))

	} else {
		callback()

	}


}
// 生成表单校验规则、表单存储对象
export const formObject = (fieldTemp) => {
	const temp = Object.keys(fieldTemp)
	let formRule = {}, formItem = {}, formJson = {}
	temp.map(key => {
		fieldTemp[key].map(e => {
			let placeholder = '', value = ''
			if (e.require) {
				if (e.type == 'TEXT' || e.type == 'LONG_TEXT' || e.type == 'NUMBER') {
					placeholder = '请输入' + e.name
					value = e.type == 'NUMBER' ? undefined : ''
				} else if (e.type == 'OPTION_SET_SINGLE' || e.type == 'OPTION_SET_MULTIPLE' || e.type == 'DATETIME' || e.type == 'DATE') {
					placeholder = '请选择' + e.name
					value = ''
				}
				if (e.type == 'NUMBER') {
					formRule[e.id] = [{ required: true, message: placeholder, type: 'number', trigger: "change" }]
				} else if (e.type == 'TEXT' || e.type == 'LONG_TEXT') {
					formRule[e.id] = [
						{ required: true, message: placeholder, trigger: "change" },
						{ required: true, validator: validateCN, trigger: "change" }
					]
				} else {
					formRule[e.id] = [{ required: true, message: placeholder, trigger: "change" }]
				}

				// 电话
				if (e.id === "shipperContactNumber" || e.id === "consigneeContactNumber" || e.id === "actualContactNumber" || e.id === "notifierContactNumber") {
					formRule[e.id] = [{ required: true, message: "20个字符以内", trigger: 'blur' },
					{ min: 0, max: 20, message: '长度小于等于20', trigger: 'blur' },
					{ required: true, validator: validateNum, trigger: "blur" }]
				}

				if (e.id === "actualContactPerson") {
					formRule[e.id] = [{ required: true, message: "20个字符以内", trigger: 'blur' },
					{ min: 0, max: 20, message: '长度小于等于20', trigger: 'blur' },
					{ required: true, validator: validateCN, trigger: "blur" }]
				}

				// 名称
				if (e.id === "shipperName" || e.id === "consigneeName" || e.id === "notifierName") {
					formRule[e.id] = [{ required: true, message: "请输入名称，70个字符以内", trigger: 'blur' },
					{ min: 0, max: 70, message: '长度小于等于70', trigger: 'blur' },
					{ required: true, validator: validateDz, trigger: "blur" }]
				}

				// 地址
				if (e.id === "shipperAddress" || e.id === "consigneeAddr" || e.id === "notifierAddress") {
					formRule[e.id] = [{ required: true, message: "请输入地址，140个字符以内", trigger: 'blur' },
					{ min: 0, max: 140, message: '长度小于等于140', trigger: 'blur' },
					{ required: true, validator: validateDz, trigger: "blur" }]
				}

				// 提单号
				if (e.id === "billNo") {
					formRule[e.id] = [{ required: true, message: '请输入提单号', trigger: 'blur' },
					{ min: 6, max: 30, message: '长度在6到30之间', trigger: 'blur' },
					{ required: true, validator: validateEX, trigger: "blur" }]
				}
				// 船名
				if (e.id === "shipName") {
					formRule[e.id] = [
						// { required: true, message: '只能是大写字符,数字和-', trigger: 'blur' },
						{ min: 0, max: 35, message: '长度小于等于35', trigger: 'blur' },
						{ required: true, validator: validateCM, trigger: "blur" }]
				}
				// 航次
				if (e.id === "voyageNo") {
					formRule[e.id] = [
						// { required: true, message: '只能是大写字符,数字和-', trigger: 'blur' },
						{ min: 0, max: 10, message: '长度小于等于10', trigger: 'blur' },
						{ required: true, validator: validateCM, trigger: "blur" }]
				}
				// 国家代码
				if (e.id === ('shipperCountryCode')) {
					formRule[e.id] = [
						{ required: true, message: placeholder, trigger: "change" },
						{ max: 5, message: '长度为2', trigger: 'change' },
						{ required: true, validator: validateGJ, trigger: "change" }
					]
				}

				if (e.id === ('consigneeCountryCode' || 'notifierCountryCode')) {
					formRule[e.id] = [
						{ required: true, message: placeholder, trigger: "change" },
						{ max: 2, message: '长度为2', trigger: 'change' },
						{ required: true, validator: validateGJ, trigger: "change" }
					]
				}

				if (e.id === ('notifierCountryCode')) {
					formRule[e.id] = [
						{ required: true, message: placeholder, trigger: "change" },
						{ max: 2, message: '长度为2', trigger: 'change' },
						{ required: true, validator: validateGJ, trigger: "change" }
					]
				}

			}
			// 企业代码
			if (e.id === ('shipperEnterpriseCode' || 'consigneeEnterpriseCode' || 'notifierEnterpriseCode')) {
				formRule[e.id] = [
					{ required: false, message: placeholder, trigger: "blur" },
					{ required: false, validator: validateAdd, trigger: "blur" }
				]
			}
			formItem[e.id] = value
			if (e.id === 'shipperCountryCode') {
				formItem[e.id] = 'CN'

			}
			formJson[e.id] = e.name
		})
	})

	return { formRule, formItem, formJson }
}

const validateRange = (rule, value, callback) => {
	console.log(value)
	// if (regCNN.test(value) === false) {
	// 	callback(new Error('不能输入中文及中文字符'))
	// } else {
	// 	callback()
	// }
	callback()
}

export const grabShipName = {
	'COSCO_C': 'COSCO-中远海-Channel C'
}

// 生成抢舱表单校验规则、表单存储对象
export const grabObject = (fieldTemp) => {
	const temp = Object.keys(fieldTemp)
	let formRule = {}, formItem = { containers: [] }, formJson = {}, boxForm = {}
	temp.map(key => {
		let boxItem = {}
		fieldTemp[key].map(e => {
			let placeholder = '', value = ''
			if (e.require) {
				// 生成表单数据
				if (e.type == 'TEXT' || e.type == 'LONG_TEXT' || e.type == 'NUMBER') {
					placeholder = '请输入' + e.name
					value = e.type == 'NUMBER' ? undefined : ''
				} else if (e.type == 'OPTION_SET_SINGLE' || e.type == 'OPTION_SET_MULTIPLE' || e.type == 'DATETIME' || e.type == 'DATE') {
					placeholder = '请选择' + e.name
					value = ''
				} else if (e.type == 'DATE_TIME_PICKER' || e.type == 'DATE_PICKER') {
					placeholder = '请选择' + e.name
					value = ''
				}

				// 生成校验规则
				if (e.type == 'TEXT' || e.type == 'LONG_TEXT') {
					formRule[e.id] = [
						{ required: true, message: placeholder, trigger: "change" },
						{ required: true, validator: validateCN, trigger: "change" }
					]
				} else if (e.type == 'NUMBER') {
					formRule[e.id] = [{ required: true, message: placeholder, type: 'number', trigger: "change" }]
				} else if (e.type == 'DATE_TIME_PICKER') {
					formRule[e.id] = [
						{ required: true, message: placeholder, trigger: "change" },
						// { required: true, validator: validateRange, trigger: "change" }
					]
				} else {
					formRule[e.id] = [{ required: true, message: placeholder, trigger: "change" }]
				}
			}
			boxItem[e.id] = value
			formJson[e.id] = e.name
			if (key != '集装箱信息') {
				formItem[e.id] = value
			}
		})
		if (key == '集装箱信息') {
			boxForm = boxItem
			formItem.containers.push(boxItem)
		}
	})
	return { formRule, formItem, formJson, boxForm }
}

//  产品管理
export const productList = [
	{ productId: "1", nameEn: 'VGM发送', nameCn: 'VGM发送', describe: "全口岸覆盖 一站式通道", logo: 'https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/market_v2/user/product/vgm.png' },
	{ productId: "2", nameEn: 'cps', nameCn: '上海预配舱单', describe: "快速回执，智能审核", logo: 'https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/market_v2/user/product/cps.png' },
	{ productId: "3", nameEn: 'sail', nameCn: '箱货跟踪', describe: "船港箱货，运输节点全程追踪", logo: 'https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/market_v2/user/product/sail.png' },
	{ productId: "4", nameEn: 'tro_c', nameCn: '船期查询', describe: "船舶动态实时查询", logo: 'https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/market_v2/user/product/tro_c.png' },
	{ productId: "5", nameEn: 'asm', nameCn: 'AMS发送', describe: "提供SCAC code，安全简单", logo: 'https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/market_v2/user/product/asm.png' },
	{ productId: "6", nameEn: 'em&aci', nameCn: 'EM&ACI', describe: "提供8000code，发送无门槛", logo: 'https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/market_v2/user/product/em&aci.png' },
	{ productId: "7", nameEn: 'afr', nameCn: 'AFR发送', describe: "不限船司，不限港口", logo: 'https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/market_v2/user/product/afr.png' },
]

export const stateList = {
	//  付款方式
	payType: [
		{ value: '1', label: '支付宝' },
		{ value: '2', label: '微信' },
		{ value: '3', label: '余额' },
		{ value: '4', label: '对公转账' },
		{ value: '5', label: '赠送u币' },
		{ value: '6', label: '银联' },
	],
	// 开票状态
	payStatus: [
		{ value: '0', label: '未开票' },
		{ value: '1', label: '已开票' },
		{ value: '2', label: '开票中' },
		{ value: '3', label: '开票失败' },
		{ value: '4', label: '无法开票' },
		{ value: '5', label: '部分开票' },
	]
}

//代理新版菜單
export const agentMenuList = [
	{
		name: "首页",
		id: 9,
		icon: "iconfont icon-shouye",
		url: "/homePage",
		children: []
	},
	{
		name: "基本信息",
		id: 10,
		icon: "iconfont icon-jibenxinxi",
		url: "/info",
		children: []
	},
	{
		name: "企业信息",
		id: 20,
		icon: "iconfont icon-qiyexinxi",
		url: "/button",
		children: [
			{
				id: 21,
				parentid: 2,
				name: "企业认证",
				icon: "",
				url: "/certification",
				children: []
			},
			{
				id: 22,
				parentid: 1,
				name: "成员管理",
				icon: "",
				url: "/member",
				children: []
			},
		]
	},
	{
		name: "财务管理",
		id: 30,
		icon: "iconfont icon-caiwuguanli",
		url: "",
		children: [
			{
				id: 31,
				parentid: 2,
				name: "余额充值",
				icon: "",
				url: "/balance",
				children: []
			},
			{
				id: 34,
				parentid: 3,
				name: "充值记录",
				icon: "",
				url: "/recharge",
				children: []
			},
			{
				id: 33,
				parentid: 2,
				name: "消费记录",
				icon: "",
				url: "/consumption",
				children: []
			},
			{
				id: 32,
				parentid: 2,
				name: "开票记录",
				icon: "",
				url: "/invoicing",
				children: []
			},
		]
	},
	{
		name: "常用收发通",
		id: 40,
		icon: "iconfont icon-changyongshoufatong",
		url: "/sendList",
		children: [],
	}
]
export let menuList = agentMenuList